<template>
    <b-modal ref="booking-conditions-modal-ref" hide-footer hide-header>
      <div class="vtd-modal-content">
        <div class="vtd-modal-header">
          <h5 v-if="userData" class="vtd-modal-title">
            Booking Conditions for booking number
            <strong style="text-transform: uppercase">{{
            userData.bookno
          }}</strong>
          </h5>
          <button type="button" class="close" aria-label="Close" @click="closeModal">
            <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
          </button>
        </div>
        <div class="vtd-modal-body">
          <div class="mb-5" v-if="flightOnly">
            <h6 v-if="bcMessageType === 'TF Conditions Only'">
              Trailfinders is acting as the Agent for your booking and as such we have arranged for you to enter a contract with the airline(s).
              The airline(s) terms and conditions apply to your booking and can be found below.
            </h6>
            <h6 v-if="bcMessageType === 'Airline Conditions Only'">
              Trailfinders is acting as the Agent for your booking and as such we have arranged for you to enter a contract with the airline(s).
              The airline(s) terms and conditions apply to your booking and can be found by clicking on the name of the airline(s) shown in green.
              If any flights are operated by a codeshare / partner airline, their terms and conditions will apply and we can provide a copy of these upon request. 
            </h6>
            <h6 v-if="bcMessageType === 'TF & Airline Conditions'">
              Trailfinders is acting as the Agent for your booking and as such we have arranged for you to enter a contract with the airline(s).
              The airline(s) terms and conditions apply to your booking and can be found by clicking on the name of the airline(s) shown in green 
              (please note that if any linked flights are operated by a codeshare / partner airline, their terms and conditions will apply and we can provide a copy of these upon request). For other airline(s) on your booking,
              please refer to the terms and conditions in the concertina sections listed below
            </h6>
          </div>
          <span v-if="supplierBookingConditions && supplierBookingConditions.length && !bookingConditions.error">
            <div v-for="(supplier, supplierIndex) in supplierBookingConditions" :key="supplierIndex">
              <h6 v-if="supplier.type === 'ground' && supplier.suppliers.length >= 1 && !flightOnly">
                    Trailfinders is acting as the Agent for your booking and as such we have arranged for you to enter into
                    a contract with the Principal travel provider. The Principal's terms and conditions apply to your
                    booking and can be found by following the link(s) below.
                  </h6>
                  <div v-for="supp, index in supplier.suppliers" :key="index">
                    <a target="_blank" :href="supp.url">{{ supp.supplier }}</a>
                    <div v-if="supp.add_url">
                      <a target="_blank" :href="supp.add_url">Additional Conditions</a>
                    </div>
                  </div>
            </div>
          </span>
          <div v-if="bookingConditions && Object.keys(bookingConditions).length && bookingConditions.error !== true && !bookingConditions.error" class="container_12">
            <div id="navContent" class="row-fluid">
              <div>
                <div class="d-flex justify-content-end">
                  <b-button class="expand-collpase-btn" :class="{ 'item-active': dropDown }" id="expand-collapse"
                    size="sm" @click="toggleExpand" v-b-toggle.checkInCard>
                    <div class="item-title">
                      <span>Expand/Collapse All</span>
                    </div>
                    <div class="toggle-essential">
                      <span v-if="!dropDown">+</span>
                      <span v-else>-</span>
                    </div>
                  </b-button>
                </div>
                <div v-for="(item, index) of bookingConditions" :key="index">
  
                  <b-button variant="light" class="check-in-main w-100 ml-0 mr-0 mt-1 mb-1" :class="{ 'item-active': dropDown }" :id="'buttonID-' + index" size="sm"
                    v-b-toggle="'accordion-' + index" :ref="'buttonId' + index" @click="toggleIndividualExpand(index)">
                    <div class="item-title">
                      <span>{{ item.title }} </span>
                    </div>
                    <div class="toggle-essential">
                      <span class="toggle-essential" :id="`plus-${index}`">
                      + 
                    </span>
                    <span class="toggle-essential hidden" :id="`minus-${index}`">
                      -
                    </span>
                    </div>
                   
                  </b-button>
  
                  <b-collapse :id="'accordion-' + index" accordion="check-in-accordion" role="tabpanel">
                    <div class="item-dropdown accordions show">
                      <div class="item-dropdown-main accordions-main">
                        <div class="extra-info-essentials">
                          <div>
                            <p v-html="item.content"></p>
                          </div>
  
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
  
            </div>
          </div>
          <ServiceErrorMessage :error-loading-data="errorLoadingData" />
  
          <div class="btn-wrap mt-4">
            <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
              <small>This information was generated at:
                <strong class="return-date">{{ returnDate }}</strong></small>
            </div>
          </div>
        </div>
        <LoginToken ref="LoginTokenRef" />
      </div>
    </b-modal>
  </template>
  
  <script>
  import LoginToken from "@/modules/auth/login-token";
  import ServiceErrorMessage from "@/partials/service-error-message";
  import { getBookingConditions, getSupplierBookingConditions } from "./service";
  import { mapGetters, mapState } from "vuex";
  
  const { VUE_APP_VT_API_URL, NODE_ENV } =
    process.env
  export default {
    components: {
      LoginToken,
      ServiceErrorMessage
    },
    data() {
      return {
        bookingConditions: {},
        supplierBookingConditions: [],
        dropDown: false,
        errorLoadingData: false,
        bcMessageType: 'TF Conditions Only'
      };
    },
    computed: {
      ...mapState("auth", ["token"]),
      ...mapGetters({
        userData: "auth/getUserData",
        bookingContacts: "booking/getBookingContacts",
        bookingNumber: "booking/getBookingNumber",
        bookingName: "booking/getBookingSurname",
        accountInfo: "booking/getAccount",
        departureDate: "booking/getDeptDate",
        bookingData: 'booking/getBooking',
        isAuthorisedWithToken: "auth/isAuthorisedWithToken",
        paxNames: "booking/getBookingPassengers",
        booking: "booking/getBooking",
        isInternal: "getInternal"
      }),
      returnDate() {
        return new Date().toLocaleString();
      },
      flightOnly() {
        const { cond_code } = this.booking.booking_information.holiday_type
        if (cond_code && cond_code === 'FOB') {
          // Is Flight Only
          return true
        } 
        // Not FLight Only
        return false
      },
      isIrishBooking() {
        return this.bookingNumber.indexOf("R") === 0 ? true : false;
      },
    },
    methods: {
      toggleIndividualExpand(index) {
        const accordions = document.querySelectorAll('[id^="buttonID-"]');
        const pluss = document.querySelectorAll(`[id^="plus-"]`);
        const minuss = document.querySelectorAll(`[id^="minus-"]`);
        accordions.forEach((accordion, i) => {
          if (i === index) {
            if (accordion.classList.contains('item-active')) {
              accordion.classList.remove('item-active');
              minuss[index].classList.add('hidden');
              pluss[index].classList.remove('hidden');
            } else {
              accordion.classList.add('item-active');
              minuss[index].classList.remove('hidden');
              pluss[index].classList.add('hidden');
            }
          }
        });
      },
      toggleExpand() {
        this.dropDown = !this.dropDown;
        const accordions = document.querySelectorAll('[id^="accordion-"]');
        const pluss = document.querySelectorAll(`[id^="plus-"]`);
        const minuss = document.querySelectorAll(`[id^="minus-"]`);
  
        if (this.dropDown) {
          accordions.forEach((accordion) => {
            accordion.classList.add('collapse', 'show');
            accordion.removeAttribute('style');
          });
          minuss.forEach((minus) => {
            minus.classList.remove('hidden');
          });
          pluss.forEach((plus) => {
            plus.classList.add('hidden');
          });
        } else {
          accordions.forEach((accordion) => {
            accordion.classList.remove('collapse', 'show');
            accordion.style.display = 'none';
          });
          minuss.forEach((minus) => {
            minus.classList.add('hidden');
          });
          pluss.forEach((plus) => {
            plus.classList.remove('hidden');
          });
        }
      },
      async showModal(panelObj) {
        const { cond_code, cond_suplist } = this.booking.booking_information.holiday_type
        const { booking_currency } = this.booking.booking_information
        this.bookingConditions = {}
        this.supplierBookingConditions = []
        this.errorLoadingData = false;
        panelObj = panelObj || 0 // optional arg 
        this.$refs["booking-conditions-modal-ref"].show();
  
  
        if (this.checkBookingConditions(cond_code)) {
          // Show loading spinner on top of the modal
          this.$store.dispatch("spinner/updateLoadingAction", true, { root: true });
          // Get content from service
          let result = await getBookingConditions(
            cond_code,
            booking_currency === '£' ? 'uk' : 'ie'
          );
  
          if (result.error === true) {
            this.errorLoadingData = true;
          }
          if (result) {
            this.bookingConditions = result;
            this.bcMessageType = 'TF Conditions Only'
          }
        } else {
          let supplier_result = await getSupplierBookingConditions(
            cond_code,
            cond_suplist.split('.').filter((code) => code !== ''),
            booking_currency === '£' ?'uk' : 'ie',
            this.bookingNumber
          );
          if (supplier_result.error === true || supplier_result[2] && supplier_result[2].list && supplier_result[2].list.error) {
            this.errorLoadingData = true;
          }
          if (supplier_result) {
            this.supplierBookingConditions = supplier_result;
            this.bcMessageType = 'Airline Conditions Only'
  
          }
          if (supplier_result[2] && !supplier_result[2].error) {
            this.bookingConditions = supplier_result[2].list;
            if (supplier_result[2].list.length) {
              this.bcMessageType = 'TF & Airline Conditions'
            }
          }
        }
        // stop spinner
        this.$store.dispatch("spinner/updateLoadingAction", false, {
          root: true
        });
      },
      checkBookingConditions(cond_code) {
        if (cond_code.includes('INS') || cond_code.includes('VIS') || cond_code.includes('BGC') || cond_code.includes('WLS') || cond_code.includes('OSB') || cond_code.includes('PKG') || cond_code.includes('OSE')) {
          return true
        } 
        return false
      },
      closeModal() {
        this.stage = 0
        this.submitError = false
        this.$refs["booking-conditions-modal-ref"].hide();
      }
    }
  };
  </script>
  <style lang="scss">
  @import "./style.scss";
  </style>